// Module
var code = `<div class="row">
    <div ng-if="\$current_user.can('dashboard.can_see_total_installs')" class="col-lg-4 col-md-6 col-xs-12">
        <rd-widget>
            <rd-widget-body>
                <div class="widget-icon orange pull-left">
                    <i class="fa fa-globe"></i>
                </div>
                <div class="title">{{ total_installs.total | number:0}}</div>
                <div class="comment">Installs</div>
            </rd-widget-body>
        </rd-widget>
    </div>
    <div ng-if="\$current_user.can('dashboard.can_see_total_purchases')" class="col-lg-4 col-md-6 col-xs-12">
        <rd-widget>
            <rd-widget-body>
                <div class="widget-icon yellow pull-left">
                    <i class="fa fa-tasks"></i>
                </div>
                <div class="title">{{ total_purchases.total | number:0}}
                    {{ total_purchases_all.total | number:0}} </div>
                <div class="comment">Purchases Count</div>
            </rd-widget-body>
        </rd-widget>
    </div>
    <div ng-if="\$current_user.can('dashboard.can_see_total_purchases_sum')" class="col-lg-4 col-md-6 col-xs-12">
        <rd-widget>
            <rd-widget-body>
                <div class="widget-icon green pull-left">
                    <i class="fa fa-usd"></i>
                </div>
                <div class="title">\${{ total_purchases_sum.total | number:0}}</div>
                <div class="comment">Purchases Sum</div>
            </rd-widget-body>
        </rd-widget>
    </div>
</div>


<div class="row">
    <div class="col-lg-6 col-md-6">
        <bfg-chart name="dashboard.DAUChart"></bfg-chart>
    </div>

    <div class="col-lg-6 col-md-6">
        <bfg-chart name="dashboard.ARPDAUChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <bfg-chart name="retention.ClassicRetentionChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;